module.exports = __webpack_public_path__ + "media/media/home/img12-a260f0e25202998db5aa05837095e762.png";